// extracted by mini-css-extract-plugin
module.exports = {"BgSearchBoxPattern":"SearchBox_BgSearchBoxPattern__MEGF2","BgSearchBox":"SearchBox_BgSearchBox__SVBdF","SearchBoxRightImg":"SearchBox_SearchBoxRightImg__8eEnF"};